module.exports = __webpack_public_path__ + "img/almond.73c67eff.svg";